import { callLnsApi } from 'utils/fetch';

export const fetchStoryCategories = (): Promise<{
  code: number;
  data: $Lns.StoryCategory[];
}> => callLnsApi('/category');
